import { ACTIONS } from '../../../constants';
import { IMetaState, TMetaActions } from './types';

const getParentUrl = (): string => {
  try {
    return window.parent.location.href;
  } catch (e) {
    // Cross-origin access blocked, fallback to current window URL
    return window.location.href;
  }
};

const initialState: IMetaState = {
  loadPageUrl: getParentUrl(),
  intentId: '',
  startUrl: window.location.href,
  origPlatform: '',
  origPageName: '',
  dealerOfferParams: undefined,
  mainOptionName: '',
};

export const metaReducer = (state = initialState, action: TMetaActions): IMetaState => {
  switch (action.type) {
    case ACTIONS.META_UPDATE_PAGE_URL: {
      return {
        ...state,
        loadPageUrl: action.loadPageUrl,
        startUrl: action.startUrl,
        referral: action.referral,
        isCopilotInitialized: action.isCopilotInitialized,
      };
    }
    case ACTIONS.META_UPDATE_INTENT_ID: {
      return {
        ...state,
        intentId: action.intentId,
        mainOptionName: action.mainOptionName,
      };
    }

    case ACTIONS.META_UPDATE_ORIG_PARAMS: {
      return {
        ...state,
        origPlatform: action.origPlatform,
        origPageName: action.origPageName,
      };
    }

    case ACTIONS.META_UPDATE_DEALER_OFFER_PARAMS: {
      return {
        ...state,
        dealerOfferParams: action.dealerOfferParams,
      };
    }

    default: {
      return state;
    }
  }
};
